import { usePlaceSpecificUrl } from '@/utils/hooks/usePlaceSpecificUrl';
import InfoRoundIcon from '@rsuite/icons/InfoRound';
import React from 'react';
import { Link } from 'react-router-dom';

export const RootTabNotFound: React.FC = () => {
  const { getPlaceSpecificUrl } = usePlaceSpecificUrl();

  return (
    <div className="flex justify-center items-center min-h-[60vh] p-8">
      <div className="text-center max-w-md">
        <div className="mb-6">
          <InfoRoundIcon
            style={{
              fontSize: '40px',
              color: '#3498db',
              opacity: 0.8,
            }}
          />
        </div>

        <h2 className="text-2xl font-medium mb-6">Page Not Found</h2>
        <p className="text-gray-600 mb-8">
          Sorry, we couldn't find the page you're looking for. It might have
          been moved or deleted.
        </p>

        <div className="flex justify-center gap-6">
          <Link
            to={getPlaceSpecificUrl('home')}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            Map
          </Link>
          <Link
            to={getPlaceSpecificUrl('list')}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            List
          </Link>
          <Link
            to={getPlaceSpecificUrl('dashboard')}
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};
